import { PanelComponent } from './../panel/panel.component';
import {
  Component,
  OnInit,
  AfterContentInit,
  ContentChildren,
  QueryList,
  OnChanges
} from '@angular/core';
declare var environment: any;

@Component({
  selector: 'app-accordion',
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.css']
})
export class AccordionComponent implements OnInit, AfterContentInit, OnChanges {
  @ContentChildren(PanelComponent)
  panels: QueryList<PanelComponent>;
  opened: boolean = true;

  ngOnInit() {}

  ngAfterContentInit() {
    this.panels.changes.subscribe(() => {
      setTimeout(() => {
        if (this.panels.toArray()[0]) {
          environment.openCollapse !== undefined ? this.opened = environment.openCollapse : this.opened = true; 
          this.panels.toArray()[0].opened = this.opened;
        }
      }, 0);
      this.panels.toArray().forEach((panel: PanelComponent) => {
        panel.toggle.subscribe(() => {
          this.openPanel(panel);
        });
      });
    });
  }

  ngOnChanges(e) {
    console.log(e);
  }

  openPanel(panel: PanelComponent) {
    this.panels.toArray().forEach(p => (p.opened = false));
    panel.opened = true;
  }
}
